/* import __COLOCATED_TEMPLATE__ from './task-suggestions-with-explorer.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type TaskSuggestion from 'embercom/models/content-service/task-suggestion';

interface Args {
  taskSuggestions: TaskSuggestion[];
  isLoading?: boolean;
}

interface Signature {
  Args: Args;
}

export default class TaskSuggestionsWithExplorer extends Component<Signature> {
  @tracked showConversationExplorer = false;
  @tracked selectedConversationIds: string[] = [];
  @tracked selectedActionName = '';
  @tracked selectedActionSummary = '';
  @tracked selectedConversationCount = 0;

  @action
  onShowConversationExplorer(
    conversationIds: string[],
    actionName: string,
    actionSummary: string,
    conversationCount: number,
  ) {
    this.selectedConversationIds = conversationIds;
    this.selectedActionName = actionName;
    this.selectedActionSummary = actionSummary;
    this.selectedConversationCount = conversationCount;
    this.showConversationExplorer = true;
  }

  @action
  onCloseConversationExplorer() {
    this.showConversationExplorer = false;
    this.selectedConversationIds = [];
    this.selectedActionName = '';
    this.selectedActionSummary = '';
    this.selectedConversationCount = 0;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TaskSuggestions::TaskSuggestionsWithExplorer': typeof TaskSuggestionsWithExplorer;
    'reporting/automation/fin-ai-agent/analyze/task-suggestions/task-suggestions-with-explorer': typeof TaskSuggestionsWithExplorer;
  }
}
